import {NgModule} from '@angular/core';
import {BuildingService} from './building.service';
import {BuildingOverviewComponent} from './building-overview.component';
import {BuildingFormComponent} from './building-form.component';
import {SharedModule} from '../shared/shared.module';
import {FloorModule} from '../floor/floor.module';
import {BuildingDatatableComponent} from './building-datatable.component';
import {TabsModule} from 'ngx-bootstrap';
import {ContactModule} from '../contact/contact.module';
import {BuildingContactFormComponent} from './building-contact-form.component';
import {DatagridModule} from '../datagrid/datagrid.module';
import {BuildingChannelOverviewComponent} from './building-channel-overview.component';

@NgModule({
  declarations: [
    BuildingOverviewComponent,
    BuildingDatatableComponent,
    BuildingFormComponent,
    BuildingContactFormComponent,
    BuildingChannelOverviewComponent,
  ],
  exports: [
    BuildingOverviewComponent,
    BuildingDatatableComponent,
    BuildingFormComponent,
  ],
  imports: [
    SharedModule,
    FloorModule,
    ContactModule,
    DatagridModule,
    TabsModule.forRoot()
  ],
  providers: [
    BuildingService
  ]
})
export class BuildingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building.module.ts